<fieldset class="ais-RefinementList" *ngIf="state.range">
  <div>
    <!-- this div is here to simulate the ng-ais-header container -->
    <button
      class="ais-RefinementList-header ais-header"
      [ngClass]="{'ais-RefinementList-header--closed': !showRefinementBody}"
      (click)="toggleShowBody()"
      [attr.aria-expanded]="showRefinementBody"
    >
      <legend *ngIf="options.label === 'CATALOG.FILTERS.PRICE.INPUT'" i18n="@@CATALOG.FILTERS.PRICE.INPUT">
        Price
      </legend>
    </button>
  </div>
  <div class="ais-RefinementList-body ais-body" [ngStyle]="{display: showRefinementBody ? 'block' : 'none'}">
    <form novalidate class="vc-price-range">
      <div class="vc-price-range__col vc-price-range__col--min">
        <input
          id="price-range-min"
          class="vc-price-range__input"
          i18n-placeholder="@@CATALOG.FILTERS.PRICE.MIN"
          placeholder="min"
          type="number"
          #priceMin
          [value]="convertPricefromCents(state.start[0]) || ''"
        />
        <label for="price-range-min" class="vc-price-range__label">
          {{ formatCurrency(convertPricefromCents(state.range?.min), options.currency) }}
        </label>
      </div>
      <div class="vc-price-range__col vc-price-range__col--max">
        <input
          id="price-range-max"
          class="vc-price-range__input"
          i18n-placeholder="@@CATALOG.FILTERS.PRICE.MAX"
          placeholder="max"
          type="number"
          #priceMax
          [value]="convertPricefromCents(state.start[1]) || ''"
        />
        <label for="price-range-max" class="vc-price-range__label">
          {{ formatCurrency(convertPricefromCents(state.range?.max), options.currency) }}
        </label>
      </div>

      <div class="vc-price-range__col vc-price-range__col--button">
        <button
          class="vc-btn vc-btn--secondary vc-btn--small"
          (click)="updatePriceRange($event, [priceMin.value, priceMax.value])"
          i18n="@@CATALOG.FILTERS.PRICE.OK"
        >
          OK
        </button>
      </div>
    </form>
  </div>
</fieldset>
